import { images } from "@/assets"

const NoData = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img src={images.no_data} className="w-[200px]" />
    </div>
  )
}

export default NoData;